import $ from 'jquery';
import Marionette from 'backbone.marionette';
import User from '../models/user.js';

/**
 * A view for managing a login form.
 *
 * @class LoginView
 */
const LoginView = Marionette.View.extend({

    template: false,

    ui: {
        email:    'input[name="email"]',
        password: 'input[name="password"]',
        submit:   'input[type="submit"]'
    },

    events: {
        'click @ui.submit': 'tryLogin'
    },

    modelEvents: {
        error: 'loginFail'
    },

    initialize: function (options) {
        this.model = new User({}, options);
        this.getUI('submit').attr('disabled', null);
    },

    tryLogin: function (event) {

        event.preventDefault();

        this.model.set({
            email:    this.getUI('email').val(),
            password: this.getUI('password').val()
        });

        this.model.login();
    },

    loginFail: function (model, response) {

        const $errorDiv =
            $(`<div class="error">${response.responseJSON.message}</div>`);

        $errorDiv.insertAfter(this.getUI('submit'));

        $('body').one('click', () => {
            $errorDiv.fadeOut();
        });
    }
});

export default LoginView;
